export default (counts, goal) => {
  if (!(counts && counts.reduce)) {
    return undefined;
  }

  if (!(typeof goal === 'number')) {
    return undefined;
  }

  return counts.reduce((prev, curr) => {
    return (Math.abs(curr - goal) < Math.abs(prev - goal) ? curr : prev);
  }, 0);
}



// WEBPACK FOOTER //
// ./utils/getNearestNumber.js